import React from 'react';
import classes from './BlogPosts.qmee.module.scss';
import { graphql, useLazyLoadQuery, usePaginationFragment } from 'react-relay';
import Head from 'next/head';
import { BlogPostsQuery } from './__generated__/BlogPostsQuery.graphql';
import { BlogPosts_posts$key } from './__generated__/BlogPosts_posts.graphql';
import PageHeader from 'components/molecules/PageHeader/PageHeader';
import BlogPostItem from './BlogPostItem.qmee';

export interface Props {}

export const BLOG_POST_COUNT = 12;

export const blogPostSlugQuery = graphql`
  query BlogPostsSlugQuery($count: Int!) {
    blogPosts(first: $count) {
      edges {
        node {
          title
          slug
          date
          description
          content
          imageUrl
        }
      }
    }
  }
`;

export const blogPostsQuery = graphql`
  query BlogPostsQuery($count: Int) {
    ...BlogPosts_posts @arguments(count: $count)
  }
`;

const blogPostsFragment = graphql`
  fragment BlogPosts_posts on Query
  @argumentDefinitions(count: { type: "Int", defaultValue: 12 }, cursor: { type: "String" })
  @refetchable(queryName: "BlogPostsPaginationQuery") {
    blogPosts(first: $count, after: $cursor) @connection(key: "BlogPosts_query_blogPosts") {
      edges {
        cursor
        node {
          id
          ...BlogPostItem_item
        }
      }
    }
  }
`;

const BlogPostsList: React.FC<{ postsRef: BlogPosts_posts$key }> = ({ postsRef }) => {
  const { data } = usePaginationFragment(blogPostsFragment, postsRef);

  return data.blogPosts ? (
    <div className={classes.root}>
      <Head>
        <link rel="alternate" type="application/rss+xml" title="Qmee Blog RSS Feed" />
      </Head>
      <PageHeader title="Community Blog" backHref="/more" />
      <div className={classes.grid}>
        {data.blogPosts.edges.map(({ node: post }) => (
          <BlogPostItem key={post.id} postRef={post} />
        ))}
      </div>
    </div>
  ) : (
    <></>
    // <ErrorPage errorDescription="We are having trouble loading our blog at the moment." />
  );
};

const BlogPosts: React.FC<Props> = () => {
  const data = useLazyLoadQuery<BlogPostsQuery>(
    blogPostsQuery,
    {
      count: BLOG_POST_COUNT,
    },
    {
      fetchPolicy: 'store-or-network',
    },
  );

  return <BlogPostsList postsRef={data} />;
};

export default BlogPosts;
